import uniquifyObject from '@utils/uniquifyObject'
import _cloneDeep from 'lodash/cloneDeep'

const requireThemeTemplates = require.context(
  '.',                      // Start at the current directory (Themes)
  true,                     // Include subdirectories
  /^\.\/[^/]+\/(?!_)[^/]+\.js$/ // Match .js files in subdirectories, excluding those starting with '_'
);

const themesTemplates = {};

requireThemeTemplates.keys().forEach((filePath) => {
  // filePath examples:
  // './BLACK_FRIDAY/template1.js'
  // './MONOCHROME/template3.js'

  // Exclude WIP themes
  if (filePath.startsWith('./_') || filePath.startsWith('./_')) {
    return;
  }

  // Exclude this file (./all.js) if it somehow matches
  if (filePath === './all.js' || filePath === './allThemeTemplates.js') return;

  // Extract the theme name and template name from the file path
  const pathParts = filePath.split('/');
  if (pathParts.length !== 3)  {
    return;
  }

  const themeName = pathParts[1];           // e.g., 'Black Friday'
  const templateFileName = pathParts[2];    // e.g., 'template1.js'

  // Exclude files starting with '_', like '_themeBase.js'
  if (templateFileName.startsWith('_')) {
    return;
  }

  // Remove the file extension to get the template name
  const templateName = templateFileName.replace(/\.js$/, ''); // e.g., 'template1'

  // Import the module
  const module = requireThemeTemplates(filePath);

  // Initialize the theme in the themesTemplates object if it doesn't exist
  if (!themesTemplates[themeName]) {
    themesTemplates[themeName] = {};
  }

  // Add the template to the corresponding theme
  themesTemplates[themeName][templateName] = {
    json: uniquifyObject(_cloneDeep(module.json)),
    info: module.info,
  };
});

export default themesTemplates;